/**
 * Accueil de l'habitant (chantier 7, étape 4, maquette 18) : en tête, l'ALERTE EN COURS ;
 * plus bas, « La mairie vous informe » (consultations ouvertes où il n'a pas voté).
 * Décision d'Henrico (24/09) : ce que la mairie communique se met sur la première page.
 * Mêmes routes qu'avant.
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';

export function AlerteEnCoursBanner() {
  const [a, setA] = useState<{ titre: string; message: string } | null>(null);
  useEffect(() => { api.grc.alertes.active().then((r) => setA(r.alerte ? { titre: r.alerte.titre, message: r.alerte.message } : null)).catch(() => setA(null)); }, []);
  if (!a) return null;
  return (
    <Link to="/mes-alertes" role="alert" className="mt-4 block rounded-r-xl border border-urgent/50 bg-urgent/10 p-3 text-ink hover:bg-urgent/15">
      <p className="text-2xs font-semibold uppercase tracking-wider text-urgent">Alerte en cours</p>
      <p className="mt-1 text-sm font-medium">{a.titre}</p>
      {a.message && <p className="mt-0.5 line-clamp-2 text-xs text-ink-muted">{a.message}</p>}
    </Link>
  );
}

export function MesInfosCard() {
  const [infos, setInfos] = useState<Array<{ id: string; titre: string }> | null>(null);
  useEffect(() => {
    api.referendumsCitoyen.list()
      .then((r) => setInfos(r.referendums.filter((x) => x.statut === 'open' && !x.monVoteOptionId).map((x) => ({ id: x.id, titre: x.question }))))
      .catch(() => setInfos([]));
  }, []);
  if (!infos || infos.length === 0) return null;
  return (
    <section aria-label="La mairie vous informe" className="mt-4 rounded-r-xl border border-border bg-surface/55 p-4">
      <h2 className="mb-1 text-base font-semibold text-ink">La mairie vous informe</h2>
      <ul>
        {infos.map((i) => (
          <li key={i.id} className="border-t border-border/60 first:border-t-0">
            <Link to="/mes-referendums" className="flex items-center gap-3 py-3 text-sm text-ink hover:text-accent">
              <span className="min-w-0 flex-1 truncate">Consultation : {i.titre}</span>
              <span className="flex-shrink-0 rounded-r-pill bg-grc/15 px-2.5 py-0.5 text-2xs font-medium text-grc-fg">Donner mon avis</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
